// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCJ7vntiP9mgryX5IgPF4v0dpGPU7yP-kk",
    authDomain: "employeetracker-401f3.firebaseapp.com",
    projectId: "employeetracker-401f3",
    storageBucket: "employeetracker-401f3.firebasestorage.app",
    messagingSenderId: "644429137581",
    appId: "1:644429137581:web:283fad3cb2b5d28e99a824"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);